import script from "./TOCC.vue?vue&type=script&setup=true&lang=ts"
export * from "./TOCC.vue?vue&type=script&setup=true&lang=ts"

import "./TOCC.vue?vue&type=style&index=0&id=3adc9ade&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3adc9ade"]])

export default __exports__